import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

export default function NotFound() {
  const { lang, t } = useLang();
  const pl = lang === "pl";

  return (
    <div
      data-testid="not-found-page"
      className="min-h-[70vh] flex items-center"
    >
      <div className="container-art w-full grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
        <div className="md:col-span-7">
          <div className="overline mb-6">404 · {pl ? "Nie znaleziono" : "Not found"}</div>
          <h1 className="font-heading text-6xl md:text-8xl font-light tracking-tighter leading-[0.95] text-balance">
            <span className="block">{pl ? "Cisza." : "Silence."}</span>
            <span className="block italic text-foreground/70">
              {pl ? "Tej strony nie ma." : "This page is not here."}
            </span>
          </h1>
          <p className="mt-8 max-w-md font-body text-base font-light text-foreground/70 leading-relaxed">
            {pl
              ? "Adres, którego szukasz, nie istnieje w pracowni. Wróć na stronę główną albo zajrzyj do galerii."
              : "The address you are looking for does not exist in the studio. Return to the main page or visit the gallery."}
          </p>
          <div className="mt-12 flex flex-wrap items-center gap-8">
            <Link
              to="/"
              data-testid="404-home"
              className="inline-flex items-center gap-3 bg-ink text-bone px-7 py-3.5 text-[12px] uppercase tracking-[0.28em] font-medium hover:bg-ink/85 transition-colors"
            >
              {pl ? "Strona główna" : "Home"}
              <ArrowUpRight size={14} strokeWidth={1.5} />
            </Link>
            <Link
              to="/galeria"
              data-testid="404-gallery"
              className="link-underline text-[12px] uppercase tracking-[0.28em] font-medium inline-flex items-center gap-2"
            >
              {t.nav.gallery}
              <ArrowUpRight size={14} strokeWidth={1.5} />
            </Link>
          </div>
        </div>

        <div className="md:col-span-5 hidden md:block">
          <div className="font-heading font-light tracking-[-0.04em] leading-[0.85] text-[clamp(8rem,22vw,22rem)] text-foreground/8 text-right select-none">
            404
          </div>
        </div>
      </div>
    </div>
  );
}
